import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { useHistory, Redirect } from 'react-router-dom';

import api from "~/services/api";
import ApiBullets from "~/services/Bulletins/api";
import Loading from '~/components/layout/Loading';
import { useSelector, useDispatch } from 'react-redux';
import SideBar from '~/components/layout/Sidebar';
import Header from '~/components/layout/Header';
import apiLapidar from '~/services/Lapidar/api';
import BackPage from '~/components/layout/BackPage';
import ModalFilter from '~/components/pages/SegmentedComunication/ModalFilter';
import information from '~/assets/images/information.svg';
import { toast } from 'react-toastify';
import filtericon from '~/assets/images/filter.svg';
import ChallengesContainer from './styles';
import OpenChatBot from '~/components/layout/Chatbot';
import NotificationPopup from '~/pages/SegmentedComunication/NotificationPopup/PopupDetail';
import NotificationPush from '~/pages/SegmentedComunication/NotificationPush/PushDetail';
import { formatCNPJ, checkSubString } from '~/utils/utils';

export const Types = {
  DAYS_90: 'DAYS_90',
  DAYS_60: 'DAYS_60',
  DAYS_30: 'DAYS_30',
  DAYS_15: 'DAYS_15',
  DAYS_7: 'DAYS_7',
  DAYS_1: 'DAYS_1',
};

const SegmentedComunication = () => {
  const host_name = window.location.host;
  const dispatch = useDispatch();

  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );
  const notificationReducer = useSelector(
    state => state.notificationReducer,
  );

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);

  const [notificationData, setNotificationData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [beginDate, setBeginDate] = useState(moment(`${(new Date()).getFullYear()}-01-01`).format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [beginDateFilter, setBeginDateFilter] = useState('');
  const [endDateFilter, setEndDateFilter] = useState('');
  const [updateRequest, setUpdateRequest] = useState(false);
  const [readStatusFilter, setReadStatusFilter] = useState(null);
  const [activeStatusFilter, setActiveStatusFilter] = useState(null);
  const [word, setWord] = useState('');
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [notification, setNotification] = useState({});
  const [notificationPush, setNotificationPush] = useState({});
  const [showModalPush, setShowModalPush] = useState(false);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem("access_token"),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    setNotificationData(notificationReducer.notifications);
  }, [notificationReducer.notifications]);

  useEffect(() => {
    fetch();
  }, [economicGroupReducer.stores, economicGroupReducer.selectedStore]);

  async function getStoreSummary() {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem("access_token"),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const externalLoadIdOrStoreId = localStorage.getItem("external_load_id") ? localStorage.getItem("external_load_id") : localStorage.getItem("storeId")
      return await apiLapidar
      .get(`/store/summary?external_load_id=${externalLoadIdOrStoreId}`, parameters)
        .then((res) => {
          localStorage.setItem('category', res.data.rating);
          return res.data.rating;
        })
        .catch((err) => {
          console.err('Error in load summary data - push', err)
          return false
        })
    } catch (error) {
      console.warn("Exceção in load summary - push", error);
      return false
    }
  }

  async function loadDataMe() {
    try {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    return await api
      .get('residential/store/v1/stores/me', parameters)
      .then(res => {
        localStorage.setItem('segment', res.data.resaleSegmentation);
        localStorage.setItem('core', res.data.core);
        localStorage.setItem('market', res.data.market);
        localStorage.setItem('microMarket', res.data.microMarket);
        localStorage.setItem('branch', res.data.branch);
        localStorage.setItem('document', res.data.document);
        localStorage.setItem('state', res.data.address.stateAbbreviation);
        return res.data
      })
      .catch((err) => {
        console.err('Error in load store me - portal', err)
        return false;
      })

    } catch (error) {
      console.warn("Except in load store me - Portal", error);
      return false;
    }
  }

  async function fetchTracking(payload) {
    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/calls',
        payload,
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking call - popup.", err);
      });
    } catch (error) {
      console.warn("Exceção in tracking - Popup.", error);
      return false
    }
  }

  async function fetchTrackingRead(payload) {
    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/reads',
        payload,
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking read - page notification.", err);
      });
    } catch (error) {
      console.warn("Exceção in read - page notification.", error);
      return false
    }
  }

  async function getPayload() {
    const payload = {
      segment: '',
      market: '',
      nucleus: '',
      micro_market: '',
      lapidar: '',
      branch: '',
      state: '',
      cnpj: ''
    }

    const segment = localStorage.getItem('segment');
    const core = localStorage.getItem('core');
    const market = localStorage.getItem('market');
    const microMarket = localStorage.getItem('microMarket');
    const branch = localStorage.getItem('branch');
    const state = localStorage.getItem('state');
    const document = localStorage.getItem('storeDocument');
    if (segment && core && market && microMarket && branch && state && document){
      payload.segment = capitalizeFirstLetter(segment);
      payload.nucleus = core;
      payload.market = market;
      payload.micro_market = microMarket;
      payload.branch = branch;
      payload.state = state;
      payload.cnpj = formatCNPJ(document);
    } else {
      const responseStore = await loadDataMe();
      if (responseStore){
        payload.segment = capitalizeFirstLetter(responseStore.resaleSegmentation);
        payload.nucleus = responseStore.core;
        payload.market = responseStore.market;
        payload.micro_market = responseStore.microMarket;
        payload.branch = responseStore.branch;
        payload.state = responseStore.address.stateAbbreviation;
        payload.cnpj = formatCNPJ(responseStore.document);
      }
    }

    const summary = await getStoreSummary();
    if (summary) {
      payload.lapidar = capitalizeFirstLetter(summary);
    } else {
      payload.lapidar = "Não inscrita";
    }

    return  payload;
  }

  async function fetch() {
    let dataFetched = [];
    try {
      const payload = await getPayload();

      await api
      .post(
        '/customer-relationship/sitel/v1/popups',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);
        }
      })
      .catch(err => {
        console.log("Error get popup - page notifications", err);
      });

      await api
      .post(
        '/customer-relationship/sitel/v1/pushes',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);
        }
      })
      .catch(err => {
        console.log("Error get data in push notification", err);
      });

      await api
      .post(
        '/customer-relationship/sitel/v1/banners',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);
        }
      })
      .catch(err => {
        console.log("Error get banner in page notification", err);
      });

      dispatch({ type: "SET_NOTIFICATIONS", notifications: dataFetched });

    } catch (error) {
      console.warn("Exception in get data - notification page", error);
      return false
    }
  }

  function filterNotification(data) {
    if (data.length > 0) {
      const items = data.filter((item) => item.status === 'published');
      return items;
    }
    return [];
  }

  function orderingNotifications(old, data) {
    const newData = old.concat(data)
    const ordered = newData.sort((a, b) => new Date(a.date_published) - new Date(b.date_published));
    return ordered;
  }

  function removeDuplicated(data) {
    var reduced = [];

    data.forEach((item) => {
        var duplicated  = reduced.findIndex(redItem => {
            return item.id == redItem.id;
        }) > -1;

        if(!duplicated) {
            reduced.push(item);
        }
    });
    return reduced;
  }

  useEffect(() => {
    let filtered = notificationReducer.notifications.filter((item) => filterByDate(item.date_published, beginDate, endDate))
    if (readStatusFilter === 'READ') {
      filtered = filtered.filter((item) => item.number_of_read);
    } else if (readStatusFilter  === 'NOT_READ') {
      filtered = filtered.filter((item) => !item.number_of_read || item.number_of_read === 0);
    }

    if (activeStatusFilter === 'ACTIVE') {
      filtered = filtered.filter((item) => verifyDateValid(item));
    } if (activeStatusFilter  === 'NOT_ACTIVE') {
      filtered = filtered.filter((item) => !verifyDateValid(item));
    }

    if (word.length > 0) {
      filtered = filtered.filter((item) => searchByTitle(item.title ? item.title.toLowerCase() : null, word.toLowerCase()))
    }

    setNotificationData(filtered);
  }, [beginDate, endDate, readStatusFilter, activeStatusFilter, word]);

  function activeModal() {
    if (showModal) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }

  function activebeginDate(beginDate) {
    setBeginDateFilter(beginDate);
  }

  function activeEndDate(endDate) {
    setEndDateFilter(endDate);
  }

  async function changeFilter(type) {
    await setShowModal(false);
    switch (type) {
      case Types.DAYS_30:
        setBeginDate(moment().subtract(30, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
      case Types.DAYS_15:
        setBeginDate(moment().subtract(15, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
      case Types.DAYS_7:
        setBeginDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
      case Types.DAYS_1:
        setBeginDate(moment().format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        break;
    }
    setBeginDateFilter('');
    setEndDateFilter('');
    setUpdateRequest(!updateRequest);
  }

  async function changeFilterDate() {
    if (beginDateFilter === '' || endDateFilter === '') {
      toast.error('É necessário digitar a data inicial e final');
    } else {
      if (
        moment(beginDateFilter, 'YYYY-MM-DD').format('DD/MM/YYYY') ===
        'Invalid date'
      ) {
        toast.error('Escreva uma data inicial válida para continuar');
      } else if (
        moment(endDateFilter, 'YYYY-MM-DD').format('DD/MM/YYYY') ===
        'Invalid date'
      ) {
        toast.error('Escreva uma data final válida para continuar');
      } else {
        await setBeginDate(
          moment(beginDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        );
        await setEndDate(
          moment(endDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        );
        await setUpdateRequest(!updateRequest);
      }
    }
    await setShowModal(false);
  }

  const fDate = useCallback(date => {
    return new Date(date).toLocaleDateString('pt-br', {
      timeZone: 'UTC',
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    });
  }, []);

  function filterByDate(published, startDate, dueDate) {
    const date_published = new Date(published);
    let start = new Date(startDate);
    let due = new Date(dueDate);
    due.setDate(due.getDate() + 1);

    if (date_published >= start && date_published <= due) return true;
    return false;
  }

  function capitalizeFirstLetter(str) {
    const lower = str.toLowerCase();
    const capitalized = lower.charAt(0).toUpperCase() + lower.slice(1);
    return capitalized;
  }

  const verifyDateValid = (value) => {
    var todaysDate = new Date();

    if (!value.start_date && !value.end_date) return true;
    if (!value.start_date && value.end_date) {
      if (new Date(value.end_date) >= todaysDate) return true;
      return false;
    }
    if (value.start_date && !value.end_date) {
      if (new Date(value.start_date) <= todaysDate) return true;
      return false;
    }
    if (new Date(value.start_date) <= todaysDate && new Date(value.end_date) >= todaysDate) {
      return true;
    }
    return false;
  }

  function searchByTitle(item, word) {
    if (!item) return false;
    if (item.match(word)) return true;
    return false;
  }

  async function handleDetails(item) {
    const payload = await getPayload();
    if (item.content_style === 'banner' && item.hiperlinks && !item.content){
      if (!item.number_of_call || parseInt(item.number_of_call) === 0) {
        await fetchTracking({
          bulletinsid: item.id,
          cnpj: payload.cnpj
        })
        await fetchTrackingRead({
          bulletinsid: item.id,
          cnpj: payload.cnpj
        });
      }
      window.open(
        item.hiperlinks,
        checkSubString(item.hiperlinks, host_name) ? "_self" : "_blank"
      )
    }
    if (item.content_style === 'banner' && item.content){
      if (!item.number_of_call || parseInt(item.number_of_call) === 0) {
        await fetchTracking({
          bulletinsid: item.id,
          cnpj: payload.cnpj
        })
      }
      history.push(`/segmented-comunication-details?id=${item.id}`)
    }
    if (item.content_style === 'popup') {
      setNotification(item);
      setShowModalPush(false);
      setShowModalPopup(true);
    }
    if (item.content_style === 'push') {
      setNotificationPush(item);
      setShowModalPopup(false);
      setShowModalPush(true);
    }
  }

  return (
    <>
      <ChallengesContainer>
        <ModalFilter
          activeModal={activeModal}
          activebeginDate={activebeginDate}
          activeEndDate={activeEndDate}
          changeFilter={changeFilter}
          changeFilterDate={changeFilterDate}
          showModal={showModal}
          beginDateFilter={beginDateFilter}
          endDateFilter={endDateFilter}
          loadingPage={false}
        />
        {showModalPopup && (
          <NotificationPopup
            showModalPopup={showModalPopup}
            setShowModalPopup={setShowModalPopup}
            notification={notification}
          />
        )}
        {showModalPush && (
          <NotificationPush
            showModalPush={showModalPush}
            setShowModalPush={setShowModalPush}
            notification={notificationPush}
          />
        )}
        <SideBar menuSelected={''}>
          <Header noMarginBottom={true} />
          <ChallengesContainer.Container
            storeInfo={classificationReducer.storeClassification}
          >
            <ChallengesContainer.Content>
              <br />
              <ChallengesContainer.NavigationContainer>
                {/* <ChallengesContainer.Top>
                  <BackPage page="/portal" />
                </ChallengesContainer.Top> */}
                <ChallengesContainer.AreaTop>
                </ChallengesContainer.AreaTop>
                {loading && <Loading />}
                {!loading && (
                  <>
                    <ChallengesContainer.SectionChallenges>
                      <div className="subhead">
                        <div style={{ marginTop: 30, marginBottom: 25 }} className="challengeTitle">
                          <ChallengesContainer.DiamondIcon style={{ marginTop: '4px' }} />
                          <h3>Notificações</h3>
                        </div>
                      </div>

                      <ChallengesContainer.PageTitleContainerFilter>
                        <ChallengesContainer.DivisionFilters>

                          <ChallengesContainer.Middle>
                            <ChallengesContainer.StatusIcon src={filtericon} alt="Ícone de filtro" />
                            <ChallengesContainer.PeriodSize>Filtros:</ChallengesContainer.PeriodSize>
                            {readStatusFilter === 'NOT_READ' ? (
                              <>
                                <ChallengesContainer.FilterButtonWhite
                                  onClick={() =>
                                    setReadStatusFilter('READ')
                                  }
                                >
                                  Lido
                                </ChallengesContainer.FilterButtonWhite>
                                <ChallengesContainer.FilterButton onClick={() =>
                                    setReadStatusFilter('NOT_READ')
                                  } margin={'.5rem 1rem 0 0'}>
                                  Não lido
                                </ChallengesContainer.FilterButton>
                              </>
                            ) : (
                              readStatusFilter === 'READ' ? (
                              <>
                                <ChallengesContainer.FilterButton onClick={() =>
                                    setReadStatusFilter('READ')
                                  }>Lido</ChallengesContainer.FilterButton>
                                <ChallengesContainer.FilterButtonWhite
                                  onClick={() => setReadStatusFilter('NOT_READ')}
                                >
                                  Não lido
                                </ChallengesContainer.FilterButtonWhite>
                              </>
                              ) : (
                                <>
                                <ChallengesContainer.FilterButtonWhite onClick={() =>
                                    setReadStatusFilter('READ')
                                  }>Lido</ChallengesContainer.FilterButtonWhite>
                                <ChallengesContainer.FilterButtonWhite
                                  onClick={() => setReadStatusFilter('NOT_READ')}
                                >
                                  Não lido
                                </ChallengesContainer.FilterButtonWhite>
                                </>
                              )
                            )}
                            {activeStatusFilter === 'NOT_ACTIVE' ? (
                              <>
                                <ChallengesContainer.FilterButtonWhite
                                  onClick={() =>
                                    setActiveStatusFilter('ACTIVE')
                                  }
                                >
                                  Ativo
                                </ChallengesContainer.FilterButtonWhite>
                                <ChallengesContainer.FilterButton onClick={() =>
                                    setActiveStatusFilter('NOT_ACTIVE')
                                  } margin={'.5rem 1rem 0 0'}>
                                  Não ativo
                                </ChallengesContainer.FilterButton>
                              </>
                            ) : (
                              activeStatusFilter === 'ACTIVE' ? (
                              <>
                                <ChallengesContainer.FilterButton onClick={() =>
                                    setActiveStatusFilter('ACTIVE')
                                  }>Ativo</ChallengesContainer.FilterButton>
                                <ChallengesContainer.FilterButtonWhite
                                  onClick={() => setActiveStatusFilter('NOT_ACTIVE')}
                                >
                                  Não ativo
                                </ChallengesContainer.FilterButtonWhite>
                              </>
                              ) : (
                                <>
                                <ChallengesContainer.FilterButtonWhite onClick={() =>
                                    setActiveStatusFilter('ACTIVE')
                                  }>Ativo</ChallengesContainer.FilterButtonWhite>
                                <ChallengesContainer.FilterButtonWhite
                                  onClick={() => setActiveStatusFilter('NOT_ACTIVE')}
                                >
                                  Não ativo
                                </ChallengesContainer.FilterButtonWhite>
                                </>
                              )
                            )}
                             <ChallengesContainer.FilterButton onClick={() =>{
                                setReadStatusFilter(null);
                                setActiveStatusFilter(null);
                                setBeginDate(moment(`${(new Date()).getFullYear()}-01-01`).format('YYYY-MM-DD'));
                                setEndDate(moment().format('YYYY-MM-DD'));
                              }
                              } margin={'.5rem 1rem 0 0'}>
                              Limpar filtros
                            </ChallengesContainer.FilterButton>
                          </ChallengesContainer.Middle>

                          <ChallengesContainer.Right style={{ margin: '0rem 2rem 0 25px' }}>
                            <ChallengesContainer.StatusIcon src={filtericon} alt="Ícone de filtro" />
                            <ChallengesContainer.PeriodSize>Período:</ChallengesContainer.PeriodSize>
                            <ChallengesContainer.FilterButton onClick={() => setShowModal(true)}>
                              {beginDate === 'Invalid date'
                                ? moment().format('DD/MM/YYYY')
                                : moment(beginDate, 'YYYY-MM-DD').format(
                                    'DD/MM/YYYY',
                                  )}{' '}
                              -{' '}
                              {endDate === 'Invalid date'
                                ? moment().format('DD/MM/YYYY')
                                : moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                              <ChallengesContainer.Close>x</ChallengesContainer.Close>
                            </ChallengesContainer.FilterButton>
                          </ChallengesContainer.Right>

                          <ChallengesContainer.Right style={{ margin: '0rem 2rem 0 25px' }}>
                            <ChallengesContainer.StatusIcon src={filtericon} alt="Ícone de filtro" />
                            <ChallengesContainer.PeriodSize>Título:</ChallengesContainer.PeriodSize>
                            <ChallengesContainer.Input type="text" placeholder="Palavra chave"  onChange={(e) => setWord(e.target.value)} />
                          </ChallengesContainer.Right>

                          <ChallengesContainer.FilterMobile>
                            <ChallengesContainer.First>
                              <ChallengesContainer.StatusIcon src={filtericon} alt="Ícone de filtro" />
                              <ChallengesContainer.PeriodSize>Título:</ChallengesContainer.PeriodSize>
                              <ChallengesContainer.Input type="text" placeholder="Palavra chave"  onChange={(e) => setWord(e.target.value)} />
                            </ChallengesContainer.First>

                            <ChallengesContainer.First>
                              <ChallengesContainer.StatusIcon src={filtericon} alt="Ícone de filtro" />
                              <ChallengesContainer.PeriodSize>Período:</ChallengesContainer.PeriodSize>
                              <ChallengesContainer.FilterButton onClick={() => setShowModal(true)}>
                                {moment(beginDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} -{' '}
                                {moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                <ChallengesContainer.Close>x</ChallengesContainer.Close>
                              </ChallengesContainer.FilterButton>
                            </ChallengesContainer.First>
                            <ChallengesContainer.Second>
                              <ChallengesContainer.BoxStatus>
                                <ChallengesContainer.StatusIcon src={filtericon} alt="Ícone de filtro" />
                                <span>Filtros:</span>
                              </ChallengesContainer.BoxStatus>

                              {readStatusFilter === 'NOT_READ' ? (
                                <>
                                  <ChallengesContainer.FilterButtonWhite
                                    onClick={() =>
                                      setReadStatusFilter('READ')
                                    }
                                  >
                                    Lido
                                  </ChallengesContainer.FilterButtonWhite>
                                  <ChallengesContainer.FilterButton onClick={() =>
                                      setReadStatusFilter('NOT_READ')
                                    } margin={'.5rem 1rem 0 0'}>
                                    Não lido
                                  </ChallengesContainer.FilterButton>
                                </>
                              ) : (
                                readStatusFilter === 'READ' ? (
                                <>
                                  <ChallengesContainer.FilterButton onClick={() =>
                                      setReadStatusFilter('READ')
                                    }>Lido</ChallengesContainer.FilterButton>
                                  <ChallengesContainer.FilterButtonWhite
                                    onClick={() => setReadStatusFilter('NOT_READ')}
                                  >
                                    Não lido
                                  </ChallengesContainer.FilterButtonWhite>
                                </>
                                ) : (
                                  <>
                                  <ChallengesContainer.FilterButtonWhite onClick={() =>
                                      setReadStatusFilter('READ')
                                    }>Lido</ChallengesContainer.FilterButtonWhite>
                                  <ChallengesContainer.FilterButtonWhite
                                    onClick={() => setReadStatusFilter('NOT_READ')}
                                  >
                                    Não lido
                                  </ChallengesContainer.FilterButtonWhite>
                                  </>
                                )
                              )}
                              {activeStatusFilter === 'NOT_ACTIVE' ? (
                                <>
                                  <ChallengesContainer.FilterButtonWhite
                                    onClick={() =>
                                      setActiveStatusFilter('ACTIVE')
                                    }
                                  >
                                    Ativo
                                  </ChallengesContainer.FilterButtonWhite>
                                  <ChallengesContainer.FilterButton onClick={() =>
                                      setActiveStatusFilter('NOT_ACTIVE')
                                    } margin={'.5rem 1rem 0 0'}>
                                    Não ativo
                                  </ChallengesContainer.FilterButton>
                                </>
                              ) : (
                                activeStatusFilter === 'ACTIVE' ? (
                                <>
                                  <ChallengesContainer.FilterButton onClick={() =>
                                      setActiveStatusFilter('ACTIVE')
                                    }>Ativo</ChallengesContainer.FilterButton>
                                  <ChallengesContainer.FilterButtonWhite
                                    onClick={() => setActiveStatusFilter('NOT_ACTIVE')}
                                  >
                                    Não ativo
                                  </ChallengesContainer.FilterButtonWhite>
                                </>
                                ) : (
                                  <>
                                  <ChallengesContainer.FilterButtonWhite onClick={() =>
                                      setActiveStatusFilter('ACTIVE')
                                    }>Ativo</ChallengesContainer.FilterButtonWhite>
                                  <ChallengesContainer.FilterButtonWhite
                                    onClick={() => setActiveStatusFilter('NOT_ACTIVE')}
                                  >
                                    Não ativo
                                  </ChallengesContainer.FilterButtonWhite>
                                  </>
                                )
                              )}
                              <ChallengesContainer.FilterButton onClick={() =>{
                                  setReadStatusFilter(null);
                                  setActiveStatusFilter(null);
                                  setBeginDate(moment(`${(new Date()).getFullYear()}-01-01`).format('YYYY-MM-DD'));
                                  setEndDate(moment().format('YYYY-MM-DD'));
                                }
                                } margin={'.5rem 1rem 0 0'}>
                                Limpar filtros
                              </ChallengesContainer.FilterButton>
                              </ChallengesContainer.Second>
                            </ChallengesContainer.FilterMobile>
                          </ChallengesContainer.DivisionFilters>
                        </ChallengesContainer.PageTitleContainerFilter>

                      {loadingTable ? (
                        <Loading />
                      ) : (
                        <>
                        {  notificationData.lenght === 0
                          ? <ChallengesContainer.NoExtract>
                              <span>Nenhuma notificação encontrada</span>
                            </ChallengesContainer.NoExtract>
                          : notificationData.slice(0).reverse().map((item) => (
                                <>
                                  <ChallengesContainer.ChallengeCards>
                                    <ChallengesContainer.Points>
                                      <div className="name">
                                        <ChallengesContainer.ColorMobile>
                                          <p>{ capitalizeFirstLetter(item.title) }</p>
                                        </ChallengesContainer.ColorMobile>
                                      </div>
                                      <div className="second">
                                        <div className="criterion" style={{ marginRight: 35 }}>
                                          { fDate(item.date_published) }
                                        </div>
                                        <div className="criterion" style={{ minWidth: 80 }}>
                                          { verifyDateValid(item) ? 'Ativo' : 'Não ativo' }
                                        </div>
                                        <div className="criterion">
                                          <ChallengesContainer.ColorMobile style={{ minWidth: 80 }}>
                                          { item.number_of_read ? 'Lido' : 'Não lido' }
                                          </ChallengesContainer.ColorMobile>
                                        </div>
                                      </div>
                                    </ChallengesContainer.Points>
                                    <ChallengesContainer.Details
                                      onClick={() => handleDetails(item)}
                                    >
                                      Ver mais
                                      <ChallengesContainer.ImgDetails
                                        src={information}
                                        alt="Ícone de informações"
                                      />
                                    </ChallengesContainer.Details>
                                  </ChallengesContainer.ChallengeCards>

                                  <ChallengesContainer.ChallengeCardsMobile>
                                    <ChallengesContainer.Points>
                                      <div className="name">
                                        <ChallengesContainer.AreaName>
                                          <ChallengesContainer.ColorMobile>
                                            <p>{ capitalizeFirstLetter(item.title)}</p>
                                          </ChallengesContainer.ColorMobile>
                                          <div className="criterion">
                                          { fDate(item.date_published) }
                                          </div>
                                        </ChallengesContainer.AreaName>
                                      </div>
                                      <div className="second">
                                        <div className="criterion" style={{ minWidth: 45 }}>
                                          { verifyDateValid(item) ? 'Ativo' : 'Não ativo' }
                                        </div>
                                        <div className="criterion">
                                          <ChallengesContainer.Areadate style={{ minWidth: 45 }}>
                                            { item.number_of_read ? 'Lido' : 'Não lido' }
                                          </ChallengesContainer.Areadate>
                                        </div>
                                      </div>
                                    </ChallengesContainer.Points>
                                    <ChallengesContainer.AreaButtonMobile>
                                      <ChallengesContainer.Details
                                        onClick={() => handleDetails(item)}
                                      >
                                        Ver mais
                                        <ChallengesContainer.ImgDetails
                                          src={information}
                                          alt="Ícone de informações"
                                        />
                                      </ChallengesContainer.Details>
                                    </ChallengesContainer.AreaButtonMobile>
                                  </ChallengesContainer.ChallengeCardsMobile>
                                </>
                              ),
                            )}
                      </>
                      )}
                    </ChallengesContainer.SectionChallenges>
                  </>
                )}
              </ChallengesContainer.NavigationContainer>
            </ChallengesContainer.Content>
          </ChallengesContainer.Container>
          <OpenChatBot />
        </SideBar>
      </ChallengesContainer>
    </>
  );
};

export default SegmentedComunication;
